import ActionType from '../ActionType'
import { Auth } from 'utils/Auth'
import API_URL from 'utils/ApiUrl'
import { contactsWithEmailsByIDSelector2, groupsByID2 } from '../../selectors'
import { saveTemplate } from '../template'
import $ from 'jquery'
import AJV from 'ajv'
import { update, read } from 'actions/data'
import { receiveCampaign } from 'actions/campaign/addOrEdit'
import timeUnitsInSeconds from 'utils/timeUnitsInSeconds'
import { handleSubjectChange as handleTemplateSubjectChange } from '../template'
import { editorChange } from '../editor'

const service = 'task'

export const listTaskTypes = () => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    dispatch({ type: ActionType.Tasks.LIST_TYPES_REQUEST })

    return Auth.currentSession()
      .then(session => {
        const headerValue = `Bearer ${session.idToken.jwtToken}`

        return fetch(`${API_URL}/task/type`, {
          cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
          headers: {
            'content-type': 'application/json',
            authorization: headerValue,
          },
          method: 'GET', // *GET, POST, PUT, DELETE, etc.
          mode: 'cors', // no-cors, cors, *same-origin
          redirect: 'follow', // manual, *follow, error
          referrer: 'no-referrer', // *client, no-referrer
        })
          .then(res =>
            res.json().then(data => {
              if (!res.ok) {
                return { notOk: true, ...data }
              }
              return data
            }),
          )
          .then(
            payload => {
              if (payload && payload.notOk) {
                dispatch({
                  type: ActionType.Tasks.LIST_TYPES_FAILURE,
                  payload,
                  notOk: true,
                })
                reject(payload)
                return
              }

              dispatch({
                type: ActionType.Tasks.LIST_TYPES_SUCCESS,
                payload,
              })
              resolve(payload)
            },
            error => {
              dispatch({
                type: ActionType.Tasks.LIST_TYPES_FAILURE,
                payload: error,
              })
              reject(error)
            },
          )
      })
      .catch(err => {
        console.log(err)
        if (err.code === 'UserNotFoundException') {
          window.localStorage.clear()
          window.location.reload(true)
        }
      })
  })

export const listTasks = () => (dispatch, getState) => {
  dispatch({ type: ActionType.Tasks.LIST_REQUEST })

  return Auth.currentSession()
    .then(session => {
      const headerValue = `Bearer ${session.idToken.jwtToken}`

      return fetch(`${API_URL}/task`, {
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        headers: {
          'content-type': 'application/json',
          authorization: headerValue,
        },
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, cors, *same-origin
        redirect: 'follow', // manual, *follow, error
        referrer: 'no-referrer', // *client, no-referrer
      })
        .then(res =>
          res.json().then(data => {
            if (!res.ok) {
              return { notOk: true, ...data }
            }
            return data
          }),
        )
        .then(
          payload =>
            payload && payload.notOk
              ? dispatch({
                  type: ActionType.Data.LIST_FAILURE,
                  payload,
                  entityType: 'task',
                  notOk: true,
                })
              : dispatch({
                  type: ActionType.Tasks.LIST_SUCCESS,
                  payload,
                }),
          error =>
            dispatch({
              type: ActionType.Data.LIST_FAILURE,
              payload: error,
              entityType: 'task',
            }),
        )
    })
    .catch(err => {
      console.log(err)
      if (err.code === 'UserNotFoundException') {
        window.localStorage.clear()
        window.location.reload(true)
      }
    })
}

export const addTask = body => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    dispatch({ type: ActionType.Tasks.ADD_REQUEST, body })
    const schema = getState().tasks.schema.POST

    const addHelper = schema => {
      const ajv = new AJV({ verbose: true, allErrors: true })
      const valid = ajv
        .addSchema(schema, 'postTaskSchema')
        .validate('postTaskSchema', body)

      if (!valid) {
        dispatch({
          type: ActionType.Tasks.VALIDATION_FAILURE,
          payload: valid,
          errors: ajv.errors,
          errorsText: ajv.errorsText(),
        })
        return valid
      }

      return Auth.currentSession()
        .then(session => {
          dispatch({ type: ActionType.Tasks.VALIDATION_SUCCESS })
          const headerValue = `Bearer ${session.idToken.jwtToken}`

          return fetch(`${API_URL}/task`, {
            body: JSON.stringify(body), // must match 'Content-Type' header
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            headers: {
              'content-type': 'application/json',
              authorization: headerValue,
            },
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, cors, *same-origin
            redirect: 'follow', // manual, *follow, error
            referrer: 'no-referrer', // *client, no-referrer
          })
            .then(res =>
              res.json().then(data => {
                if (!res.ok) {
                  return { notOk: true, ...data }
                }
                return data
              }),
            )
            .then(
              payload => {
                if (payload && payload.notOk) {
                  dispatch({
                    type: ActionType.Data.CREATE_FAILURE,
                    payload,
                    entityType: 'task',
                    notOk: true,
                  })
                  reject(payload)
                  return
                }

                dispatch({
                  type: ActionType.Tasks.ADD_SUCCESS,
                  payload,
                })
                return resolve(payload)
              },
              error => {
                dispatch({
                  type: ActionType.Data.CREATE_FAILURE,
                  entityType: 'task',
                  payload: error,
                })
                return reject(error)
              },
            )
        })
        .catch(err => {
          console.log(err)
          if (err.code === 'UserNotFoundException') {
            window.localStorage.clear()
            window.location.reload(true)
          }
        })
    }

    if (schema) {
      return addHelper(schema)
    } else {
      return dispatch(getTaskSchema('POST')).then(schema => addHelper(schema))
    }
  })

export const updateTask = body => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    dispatch({ type: ActionType.Tasks.UPDATE_REQUEST, body })
    const schema = getState().tasks.schema.PUT

    const putHelper = schema => {
      const ajv = new AJV({ verbose: true, allErrors: true })
      const valid = ajv
        .addSchema(schema, 'putTaskSchema')
        .validate('putTaskSchema', body)

      if (!valid) {
        dispatch({
          type: ActionType.Tasks.VALIDATION_FAILURE,
          payload: valid,
          errors: ajv.errors,
          errorsText: ajv.errorsText(),
        })
        return valid
      }

      return Auth.currentSession()
        .then(session => {
          dispatch({ type: ActionType.Tasks.VALIDATION_SUCCESS })
          const headerValue = `Bearer ${session.idToken.jwtToken}`

          return fetch(`${API_URL}/task/${body.id}`, {
            body: JSON.stringify(body), // must match 'Content-Type' header
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            headers: {
              'content-type': 'application/json',
              authorization: headerValue,
            },
            method: 'PUT', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, cors, *same-origin
            redirect: 'follow', // manual, *follow, error
            referrer: 'no-referrer', // *client, no-referrer
          })
            .then(res =>
              res.json().then(data => {
                if (!res.ok) {
                  return { notOk: true, ...data }
                }
                return data
              }),
            )
            .then(
              payload => {
                if (payload && payload.notOk) {
                  dispatch({
                    type: ActionType.Data.UPDATE_FAILURE,
                    payload,
                    entityType: 'task',
                    notOk: true,
                  })
                  reject(payload)
                  return
                }

                dispatch({
                  type: ActionType.Tasks.UPDATE_SUCCESS,
                  payload,
                })
                return resolve(payload)
              },
              error => {
                dispatch({
                  type: ActionType.Data.UPDATE_FAILURE,
                  payload: error,
                  entityType: 'task',
                })
                return reject(error)
              },
            )
        })
        .catch(err => {
          console.log(err)
          if (err.code === 'UserNotFoundException') {
            window.localStorage.clear()
            window.location.reload(true)
          }
        })
    }

    if (schema) {
      return putHelper(schema)
    } else {
      return dispatch(getTaskSchema('PUT')).then(schema => putHelper(schema))
    }
  })

export const readTask = id => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    dispatch({ type: ActionType.Tasks.READ_REQUEST, id })

    return Auth.currentSession()
      .then(session => {
        const headerValue = `Bearer ${session.idToken.jwtToken}`

        return fetch(`${API_URL}/task/${id}`, {
          cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
          headers: {
            'content-type': 'application/json',
            authorization: headerValue,
          },
          method: 'GET', // *GET, POST, PUT, DELETE, etc.
          mode: 'cors', // no-cors, cors, *same-origin
          redirect: 'follow', // manual, *follow, error
          referrer: 'no-referrer', // *client, no-referrer
        })
          .then(res =>
            res.json().then(data => {
              if (!res.ok) {
                return { notOk: true, ...data }
              }
              return data
            }),
          )
          .then(
            payload => {
              if (payload && payload.notOk) {
                dispatch({
                  type: ActionType.Data.READ_FAILURE,
                  payload,
                  entityType: 'task',
                  notOk: true,
                })
                reject(payload)
                return
              }

              dispatch({
                type: ActionType.Tasks.READ_SUCCESS,
                payload,
              })
              resolve(payload)
            },
            error => {
              dispatch({
                type: ActionType.Tasks.READ_FAILURE,
                entityType: 'task',
                payload: error,
              })
              reject(error)
            },
          )
      })
      .catch(err => {
        console.log(err)
        if (err.code === 'UserNotFoundException') {
          window.localStorage.clear()
          window.location.reload(true)
        }
      })
  })

export const deleteTask = id => (dispatch, getState) => {
  dispatch({ type: ActionType.Tasks.DELETE_REQUEST, payload: { id } })

  return Auth.currentSession()
    .then(session => {
      const headerValue = `Bearer ${session.idToken.jwtToken}`

      return fetch(`${API_URL}/task/${id}`, {
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        headers: {
          'content-type': 'application/json',
          authorization: headerValue,
        },
        method: 'DELETE', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, cors, *same-origin
        redirect: 'follow', // manual, *follow, error
        referrer: 'no-referrer', // *client, no-referrer
      })
        .then(res =>
          res.json().then(data => {
            if (!res.ok) {
              return { notOk: true, ...data }
            }
            return data
          }),
        )
        .then(
          payload => {
            if (payload && payload.notOk) {
              dispatch({
                type: ActionType.Data.DELETE_FAILURE,
                payload,
                entityType: 'task',
              })
              return
            }

            dispatch({
              type: ActionType.Tasks.DELETE_SUCCESS,
              payload,
              id,
            })
          },
          error =>
            dispatch({
              type: ActionType.Data.DELETE_FAILURE,
              payload: error,
              entityType: 'task',
            }),
        )
    })
    .catch(err => {
      console.log(err)
      if (err.code === 'UserNotFoundException') {
        window.localStorage.clear()
        window.location.reload(true)
      }
    })
}

export const receiveTask =
  (payload, date = null, campaignSelected = null, stageIDSelected = null) =>
  (dispatch, getState) =>
    dispatch({
      type: ActionType.Tasks.RECEIVE_TASK,
      payload,
      date,
      contactsByID2: contactsWithEmailsByIDSelector2(getState()),
      groupsByID2: groupsByID2(getState()),
      templatesByID: getState().email.templatesById,
      smsTemplatesByID: getState().data?.['sms/template'],
      defaultPhoneNumber: getState().phonenumbers.defaultNumber,
      campaignSelected,
      stageIDSelected,
      assignmentPools: getState().data?.['account/ap'],
    })

export const handleFieldChange = (name, value) => dispatch =>
  dispatch({
    type: ActionType.Tasks.HANDLE_FIELD_CHANGE,
    payload: { name, value },
  })

export const handleCalendarChange = value => dispatch =>
  dispatch({
    type: ActionType.Tasks.HANDLE_CALENDAR_CHANGE,
    payload: value,
  })

export const handleTemplateNameChange = value => dispatch =>
  dispatch({
    type: ActionType.Tasks.HANDLE_TEMPLATE_NAME_CHANGE,
    payload: value,
  })

export const handleSubjectChange = value => dispatch =>
  dispatch({
    type: ActionType.Tasks.HANDLE_SUBJECT_CHANGE,
    payload: value,
  })

export const backButton = () => dispatch =>
  dispatch({ type: ActionType.Tasks.BACK_BUTTON })

export const toggleSnippetsPanel = () => dispatch =>
  dispatch({ type: ActionType.Tasks.TOGGLE_SNIPPETS_PANEL })

export const toggleVariablesPanel = () => dispatch =>
  dispatch({ type: ActionType.Tasks.TOGGLE_VARIABLES_PANEL })

export const emailEditorChange = e => dispatch =>
  dispatch({
    type: ActionType.Tasks.EMAIL_EDITOR_CHANGE,
    payload: {
      innerHtml: $('[data-role="editor"]').val(),
      innerText: e ? e.sender.body.innerText : '',
    },
  })

export const codeEditorChange = value => dispatch =>
  dispatch({
    type: ActionType.Tasks.CODE_EDITOR_CHANGE,
    payload: { innerHtml: value },
  })

export const paste = tag => dispatch =>
  dispatch({
    type: ActionType.Tasks.PASTE_TAG,
    payload: {
      innerHtml: $('[data-role="editor"]').data('kendoEditor').paste(tag),
      tag,
    },
  })

export const pasteSnippet = tag => dispatch =>
  dispatch({
    type: ActionType.Tasks.PASTE_SNIPPET,
    payload: {
      innerHtml: $('[data-role="editor"]').data('kendoEditor').paste(tag),
      tag,
    },
  })

export const clickCodeButton = () => dispatch =>
  dispatch({ type: ActionType.Tasks.CLICK_CODE_BUTTON })

export const addSMS = payload => dispatch =>
  dispatch({ type: ActionType.Tasks.ADD_SMS, payload })

export const typeSMS = payload => dispatch =>
  dispatch({ type: ActionType.Tasks.TYPE_SMS, payload })

export const defaultValueChange = (defaultValue, value) => dispatch =>
  dispatch({
    type: ActionType.Tasks.DEFAULT_VALUE_CHANGE,
    payload: { defaultValue, value },
  })

// Add new action creator
export const syncSMSBeforeSave = () => (dispatch, getState) => {
  // This will trigger any mounted SMS components to sync their state
  dispatch({ type: 'Tasks.SYNC_SMS_BEFORE_SAVE' })
  // Return a promise that resolves after a short delay to allow sync to complete
  return new Promise(resolve => setTimeout(resolve, 50))
}

export const addOrUpdateTask = () => (dispatch, getState) => {
  const addOrEdit = getState().tasks.addOrEdit
  const email = getState().email
  const description = addOrEdit.fields.smartTask.value
  const selectedActionPrediction =
    addOrEdit.fields.selectedActionPrediction.value
  const automationType = addOrEdit.automationTypeSelected
  const when_to_send =
    addOrEdit.fields.date.value &&
    Object.prototype.toString.call(addOrEdit.fields.date.value) ===
      '[object Date]' &&
    addOrEdit.fields.date.value.toISOString()
  // const from_number = addOrEdit.fromNumberSelected.value
  const tasksByID = getState().tasks.tasksByID
  const originalTask =
    addOrEdit.taskID === 'new' ? null : tasksByID[addOrEdit.taskID]
  const when_created = originalTask && originalTask.when_created
  const when =
    automationType === 'stage'
      ? {
          name: 'delay_seconds',
          property: Math.floor(
            addOrEdit.delay * timeUnitsInSeconds[addOrEdit.delayUnit],
          ),
        }
      : selectedActionPrediction.slice(0, 5) === 'group' ||
        selectedActionPrediction === 'reassignContact' ||
        selectedActionPrediction === 'removeContactFromCampaign' ||
        selectedActionPrediction === 'httpSendData' ||
        selectedActionPrediction.slice(-13) === 'NeedsFollowUp'
      ? { name: 'when_to_trigger', property: when_to_send }
      : { name: 'when_to_send', property: when_to_send }

  let post_delay_wallclock = undefined

  if (addOrEdit.fields.time?.value) {
    const utcHours = addOrEdit.fields.time.value.getUTCHours()
    const utcMinutes = addOrEdit.fields.time.value.getUTCMinutes()

    post_delay_wallclock = `${utcHours.toString().padStart(2, '0')}:${utcMinutes
      .toString()
      .padStart(2, '0')}`
  }

  const dateString =
    addOrEdit.fields.date.value &&
    `${addOrEdit.fields.date.value.toLocaleDateString()} at ${addOrEdit.fields.date.value
      .toLocaleTimeString()
      .slice(0, -6)} ${addOrEdit.fields.date.value
      .toLocaleTimeString()
      .slice(-2)}`

  const to =
    automationType === 'stage'
      ? { contact_group_ids: [], contact_ids: [] }
      : addOrEdit.select.value.length
      ? addOrEdit.select.value.reduce(
          (acc, cur) => {
            const arrayName = cur.groupID ? 'contact_group_ids' : 'contact_ids'
            const id = cur.groupID ? cur.groupID : cur.contactID

            acc[arrayName].push(id)
            return acc
          },
          { contact_group_ids: [], contact_ids: [] },
        )
      : // is this right? thinking that this condition doesn't get met
      selectedActionPrediction === 'sms'
      ? { contact_group_ids: [], contact_ids: [] }
      : {}

  const originalCampaignSelected = addOrEdit.originalCampaignSelected?.value
  const originalOwnedByID =
    originalTask && originalTask.owned_by && originalTask.owned_by.id
  const currentOwnedByID =
    (addOrEdit.stageSelected && addOrEdit.stageSelected.value) ||
    (addOrEdit.campaignSelected && addOrEdit.campaignSelected.value) ||
    null
  const originalOwnedByType =
    originalTask && originalTask.owned_by && originalTask.owned_by.type
  const currentOwnedByType =
    automationType === 'stage'
      ? 'S'
      : automationType === 'calendar'
      ? 'C'
      : null

  const addToCampaign = taskBody => {
    const add = () => {
      if (addOrEdit.campaignSelected && addOrEdit.campaignSelected.value) {
        if (automationType === 'calendar') {
          dispatch(
            update(
              null,
              'campaign',
              `/${addOrEdit.campaignSelected.value}/task/${taskBody.id}/add`,
            ),
          )
            .then(() =>
              dispatch(read(addOrEdit.campaignSelected.value, 'campaign')),
            )
            .then(campaign => dispatch(receiveCampaign(campaign)))
            .then(() => dispatch(readTask(taskBody.id)))
        } else if (automationType === 'stage') {
          dispatch(
            update(
              null,
              'campaign',
              `/${addOrEdit.campaignSelected.value}/stage/${addOrEdit.stageSelected.value}/task/${taskBody.id}/add`,
            ),
          )
            .then(() =>
              dispatch(read(addOrEdit.campaignSelected.value, 'campaign')),
            )
            .then(campaign => dispatch(receiveCampaign(campaign)))
            .then(() => dispatch(readTask(taskBody.id)))
        }
      }
      return taskBody
    }

    if (taskBody.id !== 'new' && originalTask && originalTask.owned_by) {
      if (
        originalOwnedByType === currentOwnedByType &&
        originalOwnedByID === currentOwnedByID
      ) {
        // all the same
        return taskBody
      } else if (originalOwnedByID !== currentOwnedByID) {
        if (originalOwnedByID) {
          // remove it
          if (originalOwnedByType === 'C') {
            // remove from calendar
            return dispatch(
              update(
                null,
                'campaign',
                `/${originalOwnedByID}/task/${taskBody.id}/remove`,
              ),
            ).then(() => add())
          }

          if (originalOwnedByType === 'S') {
            // remove from stage
            return dispatch(
              update(
                null,
                'campaign',
                // TODO: CHANGE THIS!!!
                `/${originalCampaignSelected}/stage/${originalOwnedByID}/task/${taskBody.id}/remove`,
              ),
            ).then(() => add())
          }
        }
      }
    }

    return add()
  }

  const taskEmail = (payload = null) => {
    const templateName = payload ? payload.name : email.templateName.value

    const name = addOrEdit.fields.name.value.length
      ? addOrEdit.fields.name.value
      : `Send ${templateName} ${
          automationType === 'stage'
            ? `after ${addOrEdit.delay}`
            : `on ${dateString}`
        }`

    const template_id = payload ? `${payload.id}` : email.templateID
    const preferences = getState().AccountSettings.preferences?.preferences
    const from =
      getState().tasks.addOrEdit.fromEmailSelected?.value ||
      (preferences && preferences.default_email_from)
    const accountInfo = getState().auth?.session?.idToken?.payload
    const from_name =
      getState().tasks.addOrEdit.fromName ||
      getState().AccountSettings?.settings?.business_name ||
      `${accountInfo?.given_name ? `${accountInfo.given_name} ` : ''}${
        accountInfo?.family_name || ''
      }`

    const trigger_data = {
      template_id,
      from,
      from_name,
      default_template_values: addOrEdit.defaultValues,
      to,
      use_owner_from_address: addOrEdit.fields.use_owner_from_address.value,
    }

    // const trigger_data =
    //   automationType === 'stage' ? triggerData : { ...triggerData, to }

    const body = {
      name,
      description,
      task_type_id: '1',
      owned_by:
        automationType !== 'scheduled' ? originalTask?.owned_by : undefined,
      send_email: {
        [when.name]: when.property,
        post_delay_wallclock,
        trigger_data,
      },
    }

    if (from) {
      return addOrEdit.taskID === 'new'
        ? dispatch(addTask(body)).then(result => addToCampaign(result))
        : dispatch(
            updateTask({ ...body, id: addOrEdit.taskID, when_created }),
          ).then(() => addToCampaign({ ...body, id: addOrEdit.taskID }))
    }
  }

  const taskSMS = (payload = null) => {
    // const templateName = payload ? payload.name : email.templateName.value

    const name = addOrEdit.fields.name.value.length
      ? addOrEdit.fields.name.value
      : `Send text ${
          automationType === 'stage'
            ? `after ${addOrEdit.delay}`
            : `on ${dateString}`
        }`

    const template_id = payload
      ? `${payload.id}`
      : email.templateID && email.templateID !== 'new'
      ? `${email.templateID}`
      : null

    const trigger_data = template_id
      ? {
          to,
          from_number: addOrEdit.fromNumberSelected.value,
          template_id: parseInt(template_id),
          use_owner_from_number: addOrEdit.fields.use_owner_from_number.value,
        }
      : {
          to,
          from_number: addOrEdit.fromNumberSelected.value,
          body: addOrEdit.sms.value,
          use_owner_from_number: addOrEdit.fields.use_owner_from_number.value,
        }

    if (addOrEdit.mediaUrl) {
      trigger_data.media_url = addOrEdit.mediaUrl
    }

    const body = {
      name,
      description,
      task_type_id: '2',
      owned_by:
        automationType !== 'scheduled' ? originalTask?.owned_by : undefined,
      send_sms: {
        [when.name]: when.property,
        post_delay_wallclock,
        trigger_data,
      },
    }

    return addOrEdit.taskID === 'new'
      ? dispatch(syncSMSBeforeSave()).then(() =>
          dispatch(addTask(body)).then(result => addToCampaign(result)),
        )
      : dispatch(syncSMSBeforeSave()).then(() =>
          dispatch(
            updateTask({ ...body, id: addOrEdit.taskID, when_created }),
          ).then(() => addToCampaign({ ...body, id: addOrEdit.taskID })),
        )
  }

  const groupAdd = () => {
    const name = addOrEdit.fields.name.value.length
      ? addOrEdit.fields.name.value
      : `Add contacts to ${addOrEdit.groupSelected.label} group`

    const added_contacts = addOrEdit.contactsSelectedForGroup.map(
      contactObj => contactObj.contactID,
    )
    const contactgroup_id = addOrEdit.groupSelected.groupID

    const trigger_data =
      automationType === 'stage'
        ? { contactgroup_id }
        : { contactgroup_id, added_contacts }

    const body = {
      name,
      description,
      task_type_id: '4',
      owned_by:
        automationType !== 'scheduled' ? originalTask?.owned_by : undefined,
      add_contacts_to_group: {
        [when.name]: when.property,
        post_delay_wallclock,
        trigger_data,
      },
    }

    return addOrEdit.taskID === 'new'
      ? dispatch(addTask(body)).then(result => addToCampaign(result))
      : dispatch(
          updateTask({ ...body, id: addOrEdit.taskID, when_created }),
        ).then(() => addToCampaign({ ...body, id: addOrEdit.taskID }))
  }

  const groupRemove = () => {
    const name = addOrEdit.fields.name.value.length
      ? addOrEdit.fields.name.value
      : `Add contacts to ${addOrEdit.groupSelected.label} group`

    const removed_contacts = addOrEdit.contactsSelectedForGroup.map(
      contactObj => contactObj.contactID,
    )
    const contactgroup_id = addOrEdit.groupSelected.groupID

    const trigger_data =
      automationType === 'stage'
        ? { contactgroup_id }
        : { contactgroup_id, removed_contacts }

    const body = {
      name,
      description,
      task_type_id: '5',
      owned_by:
        automationType !== 'scheduled' ? originalTask?.owned_by : undefined,
      remove_contacts_from_group: {
        [when.name]: when.property,
        post_delay_wallclock,
        trigger_data,
      },
    }

    return addOrEdit.taskID === 'new'
      ? dispatch(addTask(body)).then(result => addToCampaign(result))
      : dispatch(
          updateTask({ ...body, id: addOrEdit.taskID, when_created }),
        ).then(() => addToCampaign({ ...body, id: addOrEdit.taskID }))
  }

  const groupMove = () => {
    const name = addOrEdit.fields.name.value.length
      ? addOrEdit.fields.name.value
      : `Move contacts from ${addOrEdit.groupToRemoveFromSelected} group to ${addOrEdit.groupToAddToSelected} group`

    const contact_ids = addOrEdit.contactsSelectedForGroup.map(
      contactObj => contactObj.contactID,
    )
    const addto_contactgroup_id = addOrEdit.groupToAddToSelected.groupID
    const removefrom_contactgroup_id =
      addOrEdit.groupToRemoveFromSelected.groupID

    const trigger_data =
      automationType === 'stage'
        ? { addto_contactgroup_id, removefrom_contactgroup_id }
        : { addto_contactgroup_id, removefrom_contactgroup_id, contact_ids }

    const body = {
      name,
      description,
      task_type_id: '6',
      owned_by:
        automationType !== 'scheduled' ? originalTask?.owned_by : undefined,
      move_contacts_btwn_groups: {
        [when.name]: when.property,
        post_delay_wallclock,
        trigger_data,
      },
    }

    return addOrEdit.taskID === 'new'
      ? dispatch(addTask(body)).then(result => addToCampaign(result))
      : dispatch(
          updateTask({ ...body, id: addOrEdit.taskID, when_created }),
        ).then(() => addToCampaign({ ...body, id: addOrEdit.taskID }))
  }

  const reassignContact = () => {
    const name = addOrEdit.fields.name.value.length
      ? addOrEdit.fields.name.value
      : `Reassign contacts ${new Date(Date.now()).toLocaleString()}`

    const contact_ids = addOrEdit.contactsSelectedForGroup.map(
      contactObj => contactObj.contactID,
    )

    const assignmentPoolSelected = addOrEdit.assignmentPoolSelected
    const use_default_assignmentpool =
      getState().data?.['account/ap']?.[assignmentPoolSelected]?.name ===
      'default'

    const trigger_data =
      automationType === 'stage'
        ? {
            assign_to: {
              use_default_assignmentpool,
              assignmentpool_id: assignmentPoolSelected,
            },
          }
        : {
            contact_ids,
            assign_to: {
              use_default_assignmentpool,
              assignmentpool_id: assignmentPoolSelected,
            },
          }

    const body = {
      name,
      description,
      task_type_id: '7',
      owned_by:
        automationType !== 'scheduled' ? originalTask?.owned_by : undefined,
      reassign_contact: {
        [when.name]: when.property,
        post_delay_wallclock,
        trigger_data,
      },
    }

    return addOrEdit.taskID === 'new'
      ? dispatch(addTask(body)).then(result => addToCampaign(result))
      : dispatch(
          updateTask({ ...body, id: addOrEdit.taskID, when_created }),
        ).then(() => addToCampaign({ ...body, id: addOrEdit.taskID }))
  }

  const removeContactFromCampaign = () => {
    const name = addOrEdit.fields.name.value.length
      ? addOrEdit.fields.name.value
      : `Remove contacts from campaign ${new Date(Date.now()).toLocaleString()}`

    const contact_ids = addOrEdit.contactsSelectedForGroup.map(
      contactObj => contactObj.contactID,
    )

    const trigger_data =
      automationType === 'stage'
        ? {
            campaign_id: addOrEdit.campaignSelectedToRemoveContactFrom,
          }
        : {
            contact_ids,
            campaign_id: addOrEdit.campaignSelectedToRemoveContactFrom,
          }

    const body = {
      name,
      description,
      task_type_id: '8',
      owned_by:
        automationType !== 'scheduled' ? originalTask?.owned_by : undefined,
      remove_from_campaign: {
        [when.name]: when.property,
        post_delay_wallclock,
        trigger_data,
      },
    }

    return addOrEdit.taskID === 'new'
      ? dispatch(addTask(body)).then(result => addToCampaign(result))
      : dispatch(
          updateTask({ ...body, id: addOrEdit.taskID, when_created }),
        ).then(() => addToCampaign({ ...body, id: addOrEdit.taskID }))
  }

  const httpSendData = () => {
    const name = addOrEdit.fields.name.value.length
      ? addOrEdit.fields.name.value
      : `Send HTTP Data ${new Date(Date.now()).toLocaleString()}`

    const contact_ids = addOrEdit.contactsSelectedForGroup.map(
      contactObj => contactObj.contactID,
    )

    const trigger_data =
      automationType === 'stage'
        ? {
            thirdpartyendpoint_id: addOrEdit.endpointSelected,
          }
        : {
            contact_ids,
            thirdpartyendpoint_id: addOrEdit.endpointSelected,
          }

    const body = {
      name,
      description,
      task_type_id: '9',
      owned_by:
        automationType !== 'scheduled' ? originalTask?.owned_by : undefined,
      http_send_data: {
        [when.name]: when.property,
        post_delay_wallclock,
        trigger_data,
      },
    }

    return addOrEdit.taskID === 'new'
      ? dispatch(addTask(body)).then(result => addToCampaign(result))
      : dispatch(
          updateTask({ ...body, id: addOrEdit.taskID, when_created }),
        ).then(() => addToCampaign({ ...body, id: addOrEdit.taskID }))
  }

  const setNeedsFollowUp = () => {
    const name = addOrEdit.fields.name.value.length
      ? addOrEdit.fields.name.value
      : `Set Needs Follow-Up ${new Date(Date.now()).toLocaleString()}`

    const contact_ids = addOrEdit.contactsSelectedForGroup.map(
      contactObj => contactObj.contactID,
    )

    const trigger_data =
      automationType === 'stage'
        ? {}
        : {
            contact_ids,
          }

    const body = {
      name,
      description,
      task_type_id: '10',
      owned_by:
        automationType !== 'scheduled' ? originalTask?.owned_by : undefined,
      needsfollow_set: {
        [when.name]: when.property,
        post_delay_wallclock,
        trigger_data,
      },
    }

    return addOrEdit.taskID === 'new'
      ? dispatch(addTask(body)).then(result => addToCampaign(result))
      : dispatch(
          updateTask({ ...body, id: addOrEdit.taskID, when_created }),
        ).then(() => addToCampaign({ ...body, id: addOrEdit.taskID }))
  }

  const clearNeedsFollowUp = () => {
    const name = addOrEdit.fields.name.value.length
      ? addOrEdit.fields.name.value
      : `Clear Needs Follow-Up ${new Date(Date.now()).toLocaleString()}`

    const contact_ids = addOrEdit.contactsSelectedForGroup.map(
      contactObj => contactObj.contactID,
    )

    const trigger_data =
      automationType === 'stage'
        ? {}
        : {
            contact_ids,
          }

    const body = {
      name,
      description,
      task_type_id: '11',
      owned_by:
        automationType !== 'scheduled' ? originalTask?.owned_by : undefined,
      needsfollow_clear: {
        [when.name]: when.property,
        post_delay_wallclock,
        trigger_data,
      },
    }

    return addOrEdit.taskID === 'new'
      ? dispatch(addTask(body)).then(result => addToCampaign(result))
      : dispatch(
          updateTask({ ...body, id: addOrEdit.taskID, when_created }),
        ).then(() => addToCampaign({ ...body, id: addOrEdit.taskID }))
  }

  if (selectedActionPrediction === 'email') {
    return dispatch(saveTemplate({ type: 'email' })).then(saveTemplatePayload =>
      taskEmail(saveTemplatePayload),
    )
  } else if (selectedActionPrediction === 'sms') {
    const detectedMergeFields = addOrEdit.sms.value
      ?.match(/{{[^{}]+}}/g)
      ?.reduce((acc, el) => {
        const str = el.slice(2, -2).trim()
        if (str) {
          acc[el.slice(2, -2).trim()] = ''
        }
        return acc
      }, {})

    if (
      email?.templateID === 'new' &&
      !Object.values(detectedMergeFields || {}).length
    ) {
      return taskSMS()
    }
    return dispatch(saveTemplate({ type: 'sms' })).then(saveTemplatePayload =>
      taskSMS(saveTemplatePayload),
    )
    // return taskSMS()
  } else if (selectedActionPrediction === 'groupAdd') {
    return groupAdd()
  } else if (selectedActionPrediction === 'groupRemove') {
    return groupRemove()
  } else if (selectedActionPrediction === 'groupMove') {
    return groupMove()
  } else if (selectedActionPrediction === 'reassignContact') {
    return reassignContact()
  } else if (selectedActionPrediction === 'removeContactFromCampaign') {
    return removeContactFromCampaign()
  } else if (selectedActionPrediction === 'httpSendData') {
    return httpSendData()
  } else if (selectedActionPrediction === 'setNeedsFollowUp') {
    return setNeedsFollowUp()
  } else if (selectedActionPrediction === 'clearNeedsFollowUp') {
    return clearNeedsFollowUp()
  }
}

export const getTaskSchema = schemaType => (dispatch, getState) => {
  dispatch({ type: ActionType.Tasks.SCHEMA_REQUEST })

  const url = {
    POST: `${API_URL}/schema/${service}/${schemaType}/request/`,
    PUT: `${API_URL}/schema/${service}/${service}Id/${schemaType}/request/`,
  }
  return new Promise((resolve, reject) => {
    return fetch(url[schemaType], {
      cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
      headers: {
        'content-type': 'application/json',
        dnt: 0,
      },
      method: 'GET', // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, cors, *same-origin
      redirect: 'follow', // manual, *follow, error
      referrer: 'no-referrer', // *client, no-referrer
    })
      .then(res =>
        res.json().then(data => {
          if (!res.ok) {
            return { notOk: true, ...data }
          }
          return data
        }),
      )
      .then(
        schema => {
          dispatch({
            type: ActionType.Tasks.SCHEMA_SUCCESS,
            payload: { schema, schemaType },
          })
          resolve(schema)
        },
        error => {
          dispatch({
            type: ActionType.Tasks.SCHEMA_FAILURE,
            payload: error,
          })
          reject(error)
        },
      )
  })
}

export const toggleView = payload => dispatch =>
  dispatch({ type: ActionType.Tasks.TOGGLE_VIEW, payload })

export const manuallyToggleView = payload => dispatch =>
  dispatch({ type: ActionType.Tasks.MANUALLY_TOGGLE_VIEW, payload })

export const changeSort = payload => dispatch =>
  dispatch({ type: ActionType.Tasks.CHANGE_SORT, payload })

export const toggleGeneralPanel = () => dispatch =>
  dispatch({ type: ActionType.Tasks.TOGGLE_GENERAL_PANEL })

export const closeSnackbar = () => dispatch =>
  dispatch({ type: ActionType.Tasks.CLOSE_SNACKBAR })

export const changeAutomationType = payload => dispatch =>
  dispatch({ type: ActionType.Tasks.CHANGE_AUTOMATION_TYPE, payload })

export const toggleSplitForm = () => (dispatch, getState) =>
  dispatch({
    type: ActionType.Tasks.TOGGLE_SPLIT_FORM,
    selectedActionPrediction:
      getState().tasks.addOrEdit.fields.selectedActionPrediction.value,
  })

export const selectCampaign = payload => dispatch =>
  dispatch({ type: ActionType.Tasks.SELECT_CAMPAIGN, payload })

export const selectCampaignToRemoveContactFrom = payload => dispatch =>
  dispatch({
    type: ActionType.Tasks.SELECT_CAMPAIGN_TO_REMOVE_CONTACT_FROM,
    payload,
  })

export const selectStage = payload => dispatch =>
  dispatch({ type: ActionType.Tasks.SELECT_STAGE, payload })

export const toggleActionTypePanel = () => dispatch =>
  dispatch({ type: ActionType.Tasks.TOGGLE_ACTION_TYPE_PANEL })

export const selectGroup = payload => dispatch =>
  dispatch({ type: ActionType.Tasks.SELECT_GROUP, payload })

export const selectGroupToAddTo = payload => dispatch =>
  dispatch({ type: ActionType.Tasks.SELECT_GROUP_TO_ADD_TO, payload })

export const selectGroupToRemoveFrom = payload => dispatch =>
  dispatch({ type: ActionType.Tasks.SELECT_GROUP_TO_REMOVE_FROM, payload })

export const selectContactsForGroup = payload => dispatch =>
  dispatch({ type: ActionType.Tasks.SELECT_CONTACTS_FOR_GROUP, payload })

export const selectAssignmentPool = payload => dispatch =>
  dispatch({ type: ActionType.Tasks.SELECT_ASSIGNMENT_POOL, payload })

export const selectEndpoint = payload => dispatch =>
  dispatch({ type: ActionType.Tasks.SELECT_ENDPOINT, payload })

export const setDelay = payload => dispatch =>
  dispatch({ type: ActionType.Tasks.SET_DELAY, payload })

export const setWhenToTrigger = payload => dispatch =>
  dispatch({ type: ActionType.Tasks.SET_WHEN_TO_TRIGGER, payload })

export const clickBottomNavigation = payload => dispatch =>
  dispatch({ type: ActionType.Tasks.CLICK_BOTTOM_NAVIGATION, payload })

export const toggleBottomNav = () => dispatch =>
  dispatch({ type: ActionType.Tasks.TOGGLE_BOTTOM_NAV })

export const changeDelayUnit = payload => dispatch =>
  dispatch({ type: ActionType.Tasks.CHANGE_DELAY_UNIT, payload })

export const schedulerMounted = payload => dispatch =>
  dispatch({ type: ActionType.Tasks.SCHEDULER_MOUNTED, payload })

export const selectFromNumber = payload => dispatch =>
  dispatch({ type: ActionType.Tasks.SELECT_FROM_NUMBER, payload })

export const setMediaUrl = payload => dispatch =>
  dispatch({ type: ActionType.Tasks.SET_MEDIA_URL, payload })

export const toggleManagePhonesModal =
  (payload = null) =>
  dispatch =>
    dispatch({ type: ActionType.Tasks.TOGGLE_MANAGE_PHONES_MODAL, payload })

export const setMergeFieldsPreviewSelect = payload => dispatch =>
  dispatch({
    type: 'Tasks.SET_MERGE_FIELDS_PREVIEW_SELECT',
    payload,
  })

export const addTaskFromDialog =
  ({ dialogType }) =>
  (dispatch, getState) => {
    const addOrEdit = getState().tasks.addOrEdit

    const dateString =
      addOrEdit.fields.date.value &&
      `${addOrEdit.fields.date.value.toLocaleDateString()} at ${addOrEdit.fields.date.value
        .toLocaleTimeString()
        .slice(0, -6)} ${addOrEdit.fields.date.value
        .toLocaleTimeString()
        .slice(-2)}`

    const when_to_send =
      addOrEdit.fields.date.value &&
      Object.prototype.toString.call(addOrEdit.fields.date.value) ===
        '[object Date]' &&
      addOrEdit.fields.date.value.toISOString()
    const accountInfo = getState().auth?.session?.idToken?.payload
    const from_name =
      getState().tasks.addOrEdit.fromName ||
      getState().AccountSettings?.settings?.business_name ||
      `${accountInfo?.given_name ? `${accountInfo.given_name} ` : ''}${
        accountInfo?.family_name || ''
      }`

    if (dialogType === 'inbox') {
      const inbox = getState().inbox
      const messageType = inbox.to.current.type
      if (messageType === 'text') {
        const body = {
          name: `Send text on ${dateString}`,
          description: '',
          task_type_id: '2',
          send_sms: {
            trigger_data: {
              to: {
                contact_group_ids: [],
                contact_ids: [inbox.conversationSelected],
              },
              from_number: inbox.fromNumberSelected?.phone_number,
              body: getState().view.dialogs?.scheduling?.text,
              use_owner_from_number:
                addOrEdit.fields.use_owner_from_number.value,
            },
            when_to_send,
          },
        }
        dispatch(addTask(body))
      }

      if (messageType === 'email') {
        dispatch(
          saveTemplate({
            type: 'email',
            body: {
              Template: {
                SubjectPart: getState().email.subject.value,
                HtmlPart: getState().editor,
                TextPart: '',
              },
              name: `Send email on ${dateString}`,
            },
          }),
        ).then(saveTemplatePayload => {
          const body = {
            name: `Send email on ${dateString}`,
            description: '',
            task_type_id: '1',
            send_email: {
              trigger_data: {
                to: {
                  contact_group_ids: [],
                  contact_ids: [inbox.conversationSelected],
                },
                from: inbox.fromEmailSelected?.address,
                template_id: saveTemplatePayload.id,
              },
              when_to_send,
            },
          }
          dispatch(addTask(body)).then(() => {
            dispatch(handleTemplateSubjectChange(''))
            dispatch(editorChange(''))
          })
        })
      }
    }

    if (dialogType === 'template') {
      const typeAndID = getState()
        .router?.location?.pathname?.slice?.(11)
        ?.split?.('/')
      const type = typeAndID?.[0]
      const id = typeAndID?.[1]

      if (type === 'sms') {
        const body = {
          name: `Send text on ${dateString}`,
          description: '',
          task_type_id: '2',
          send_sms: {
            trigger_data: {
              to: {
                contact_group_ids: addOrEdit.select.value
                  ?.filter?.(el => el.groupID)
                  ?.map(el => el.groupID),
                contact_ids: addOrEdit.select.value
                  ?.filter?.(el => el.contactID)
                  ?.map(el => el.contactID),
              },
              from_number: addOrEdit.fromNumberSelected.value,
              template_id: parseInt(id),
              use_owner_from_number:
                addOrEdit.fields.use_owner_from_number.value,
            },
            when_to_send,
          },
        }
        dispatch(addTask(body))
      }

      if (type === 'email') {
        const from = addOrEdit.fromEmailSelected?.value

        const body = {
          name: `Send email on ${dateString}`,
          description: '',
          task_type_id: '1',
          send_email: {
            trigger_data: {
              to: {
                contact_group_ids: addOrEdit.select.value
                  ?.filter?.(el => el.groupID)
                  ?.map(el => el.groupID),
                contact_ids: addOrEdit.select.value
                  ?.filter?.(el => el.contactID)
                  ?.map(el => el.contactID),
              },
              from,
              template_id: id,
              from_name,
              default_template_values: addOrEdit.defaultValues,
              use_owner_from_address:
                addOrEdit.fields.use_owner_from_address.value,
            },
            when_to_send,
          },
        }
        dispatch(addTask(body))
      }
    }
  }

export const selectFromEmail = payload => dispatch =>
  dispatch({
    type: ActionType.Tasks.SELECT_FROM_EMAIL,
    payload,
  })

export const changeFromName = payload => dispatch =>
  dispatch({
    type: ActionType.Tasks.CHANGE_FROM_NAME,
    payload,
  })

export const handleMultiChange = payload => dispatch =>
  dispatch({
    type: ActionType.Tasks.HANDLE_MULTI_CHANGE,
    payload,
  })
